import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import useGetAccount from "../../api/useGetAccount";
import useListUpcomingReleases from "./api/useListUpcomingReleases";
import { formatEta } from "./formatEta";
import "./styles.css";

const ComingSoon = (): JSX.Element | null => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);
  const { upcomingReleases, isLoading } = useListUpcomingReleases();
  const { data: account } = useGetAccount(accountSlug);

  if (isLoading || upcomingReleases.length === 0) return null;

  const shortDateFormat = account?.attributes?.shortDateFormat;

  return (
    <div className="comingSoon">
      <h4>Coming Soon</h4>
      {upcomingReleases.map((release) => {
        const eta = formatEta(release.betaReleaseDate, shortDateFormat);
        return (
          <div key={release.id} className="featureRow">
            <div className="featureText">
              <div className="featureName">{release.name}</div>
              <div className="featureDescription">{release.description}</div>
            </div>
            <div className="featureControl">
              {eta && <span className="comingSoonEta">{`ETA: ${eta}`}</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ComingSoon;
